import script from "./MysticRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticRoom.vue?vue&type=script&setup=true&lang=js"

import "./MysticRoom.vue?vue&type=style&index=0&id=1dda5154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dda5154"]])

export default __exports__